export const SESSION_EXPIRED_AUTH_MESSAGE = "__SESSION_EXPIRED__";

/**
 * Returns the session-expired login modal copy for the current branding.
 */
export function getSessionExpiredMessage(isRebranded: boolean): string {
  const platform = isRebranded ? "Upserve" : "Lightspeed (U-Series)";

  return `For your security, we have automatically logged you out of the ${platform} platform. Please log back in below.`;
}

/**
 * Resolves custom auth modal copy, including the session-expired sentinel.
 */
export function resolveCustomAuthMessage(
  customAuthMessage: string | undefined,
  isRebranded: boolean
): string {
  if (customAuthMessage === SESSION_EXPIRED_AUTH_MESSAGE) {
    return getSessionExpiredMessage(isRebranded);
  }

  return customAuthMessage ?? "";
}
